import React from "react"

export default function Footer() {
  return (
    <>
      <div className="px-6 py-4 border-t border-slate-700 text-sm text-slate-400">
        © 2026 Stay Suite
      </div>
    </>
  )
}
